module.exports = __webpack_public_path__ + "img/vegetable-chickpeas-190x100.a3e7fd41.jpg";